import React from 'react';
import { Spin } from 'antd';
import { useLocationsQuery } from '../../queries/me';
import { Card, CardHead, TonePill } from '../../components';

export default function LocationsCard() {
  const { data: locations = [], isPending } = useLocationsQuery();
  return (
    <Card aria-labelledby="locations-title">
      <CardHead>
        <h2 id="locations-title">Locations</h2>
        <span>{locations.length} on file</span>
      </CardHead>
      <Spin spinning={isPending}>
        {locations.length ? (
          <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'grid', gap: 8 }}>
            {locations.map((l) => (
              <li key={l._id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                <strong>{l.name}</strong>
                {l.address?.city && (
                  <span style={{ color: '#595959' }}>
                    {l.address.city}
                    {l.address.state ? `, ${l.address.state}` : ''}
                  </span>
                )}
                <TonePill>{l.timezone}</TonePill>
              </li>
            ))}
          </ul>
        ) : (
          !isPending && <p style={{ margin: 0, color: '#8c8c8c', fontSize: 13 }}>No locations on file.</p>
        )}
      </Spin>
      <p style={{ margin: '16px 0 0', paddingTop: 12, borderTop: '1px solid #f0f0f0', fontSize: 12, color: '#8c8c8c' }}>
        Need to update company details or add a location? Contact your Agent Zero representative.
      </p>
    </Card>
  );
}
